import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var FolderFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M0 36.108v-25.98h23.467v13.357l5.133-4.208 5.133 4.208V10.127H39.6c2.75 0 4.4 1.72 4.4 3.764v22.217c0 2.044-1.568 3.702-3.5 3.702h-37c-1.932 0-3.5-1.658-3.5-3.702ZM15.467 8.643H0V6.042C0 5.018.784 4.19 1.75 4.19h10.625c.752 0 1.375.445 1.66 1.267l1.432 3.186Z"
  }));
});
FolderFill.displayName = 'FolderFill';
FolderFill.defaultProps = {
  'aria-label': 'FolderFill'
};
export default FolderFill;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/FolderFill.js
// module id = 3170
// module chunks = 11